module.exports = __webpack_public_path__ + "static/media/no_head_shot.895debb0.jpg";